import Handlebars from "handlebars"
// Dev: http://localhost:8081/businessapi/  |  Prod: https://oktobiz.com/api/
// export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "https://oktobiz.com/api/"

export const SERVER_URL = "https://oktobiz.com/api/"

export const BUSINESS_CATEGORY_URL = SERVER_URL + "businessCategory"
export const MASTER_URL = SERVER_URL + "master"
export const BUSINESS_URL = SERVER_URL + "business"
export const CONTACT_US_URL = SERVER_URL + "contactUs"
export const FORGOT_PASSWORD_URL = SERVER_URL + "forgotPassword"
export const OTP_CONFIRM_URL_TEMPLATE = Handlebars.compile(SERVER_URL + "twoFACheck?username={{username}}&otp={{otp}}")
export const RESEND_OTP_URL_TEMPLATE = Handlebars.compile(SERVER_URL + "resendOtp?username={{username}}")

export const LOGIN_POST = SERVER_URL + "login"
export const BUSINESS_STATS = SERVER_URL + "businessCount";
export const BUSINESS_LIST_GET = SERVER_URL + "business";
export const BUSINESS_LIST_PUT = SERVER_URL + "business";
export const BUSINESS_TRANSACTION_GET = SERVER_URL + "transactions"
export const BUSINESS_TRANSACTION_DETAILS = SERVER_URL + "transactionsDetails"
export const DELETE_USER = SERVER_URL + "user"
export const STRIPE_PAYMENT_INTENT_URL = SERVER_URL + "stripe/create-payment-intent";
export const STRIPE_CONFIRM_URL = SERVER_URL + "stripe/confirm-payment";
